<template>
  <div id="AddWebsiteTemplate">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-form ref="formAdd">
    <v-container class="-border">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" :href="'#/admin/websiteTemplate'">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6">
          <v-text-field label="Template name" v-model.trim="template.name" class="required pl-4 required" :rules="[rules.required]" @input="changedData"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap class="pb-4 pl-4">
        <v-flex xs12 sm6 class="mt-4 pr-4">
            <span class="pf-sub-head mb-3 custom-title">Primary color</span>
            <v-btn block :color="template.primary_color" @click="pickPrimaryColor = !pickPrimaryColor"></v-btn>
            <chrome-picker :value="template.primary_color" @input="changePrimaryColor" v-if="pickPrimaryColor"></chrome-picker>
        </v-flex>
        <v-flex xs12 sm6 class="mt-4 pr-4">
            <span class="pf-sub-head mb-3 custom-title">Secondary color</span>
            <v-btn block :color="template.secondary_color" @click="pickSecondaryColor = !pickSecondaryColor"></v-btn>
            <chrome-picker :value="template.secondary_color" @input="changeSecondaryColor" v-if="pickSecondaryColor"></chrome-picker>
        </v-flex>
        <v-flex xs12 sm6 class="mt-4 pr-4">
            <span class="pf-sub-head mb-3 custom-title">Tertiary color</span>
            <v-btn block :color="template.tertiary_color" @click="pickTertiaryColor = !pickTertiaryColor"></v-btn>
            <chrome-picker :value="template.tertiary_color" @input="changeTertiaryColor" v-if="pickTertiaryColor"></chrome-picker>
        </v-flex>
        <v-flex xs12 sm6 class="mt-4 pr-4">
            <span class="pf-sub-head mb-3 custom-title">Quaternary color</span>
            <v-btn block :color="template.quaternary_color" @click="pickQuaternaryColor = !pickQuaternaryColor"></v-btn>
            <chrome-picker :value="template.quaternary_color" @input="changeQuarternaryColor" v-if="pickQuaternaryColor"></chrome-picker>
        </v-flex>
        <v-flex xs12 sm6 class="mt-4 pr-4">
            <span class="pf-sub-head mb-3 custom-title">Background color</span>
            <v-btn block :color="template.background_color" @click="pickBackgroundColor = !pickBackgroundColor"></v-btn>
            <chrome-picker :value="template.background_color" @input="changeBackgroundColor" v-if="pickBackgroundColor"></chrome-picker>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="pt-4">
      <v-layout>
        <v-flex xs12 class="button-container pr-4 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" :href="'#/admin/websiteTemplate'">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router  */
import { create } from '../../helpers/helpers';
import swal from 'sweetalert2';
import { Chrome } from 'vue-color';

// This lets admin to add new websiteTemplate items
export default {
  name: 'AddWebsiteTemplate',
  components: {
    'chrome-picker': Chrome
  },
  data: () => ({
    selectedData: false,
    template: {
      name: '',
      primary_color: '#6a3a36',
      secondary_color: '#fcf8e3',
      tertiary_color: '#dedbcd',
      quaternary_color: '#988876',
      background_color: '#6a3a36'
    },
    pickPrimaryColor: false,
    pickSecondaryColor: false,
    pickTertiaryColor: false,
    pickQuaternaryColor: false,
    pickBackgroundColor: false,
    rules: {
      required: v => !!v.trim() || 'Template name is required.',
    }
  }),
  computed: {

    WebsiteTemplate: {
      get () {
        return this.$store.state.WebsiteTemplate;
      },
      set (val) {
        this.$store.commit('setWebsiteTemplate', val);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    // @vuese
    // Used to go back to the websiteTemplate listing page
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/admin/websiteTemplate' });
    },
    // @vuese
    // Used to show the form buttons
    changedData () {
      this.selectedData = true;
    },
    changePrimaryColor (newColor) {
      this.template.primary_color = newColor.hex;
      this.selectedData = true;
    },
    changeSecondaryColor (newColor) {
      this.template.secondary_color = newColor.hex;
      this.selectedData = true;
    },
    changeTertiaryColor (newColor) {
      this.template.tertiary_color = newColor.hex;
      this.selectedData = true;
    },
    changeQuarternaryColor (newColor) {
      this.template.quaternary_color = newColor.hex;
      this.selectedData = true;
    },
    changeBackgroundColor (newColor) {
      this.template.background_color = newColor.hex;
      this.selectedData = true;
    },
    // @vuese
    // Used to save the new FAQ item
    async save () {
      if (this.$refs.formAdd.validate()) { 
        this.selectedData = false;
        let { error, data, status } = await create('WebsiteTemplate', this.template);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.WebsiteTemplate.push(data);
          swal.fire({
            type: 'success',
            title: 'Website template was added successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/admin/websiteTemplate' });
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/WebsiteTemplate/add.vue